import { Button, Result } from 'antd';
import { DOMAIN } from 'config/api-variables';
import { useAuthenticationFormSlice } from 'modules/Authentication/slice';
import { selectAuthenticated } from 'modules/Authentication/slice/selectors';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

export default function InactiveUserPage() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { actions } = useAuthenticationFormSlice();

  const isAuthenticated = useSelector(selectAuthenticated);

  const handleLogout = () => {
    dispatch(actions.logoutStart());
  };

  useEffect(() => {
    if (!isAuthenticated) {
      navigate('/');
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated]);

  return (
    <Result
      status="403"
      title="403"
      subTitle="Sorry, you are not authorized to access this page. Please contact your administrator."
      extra={
        <>
          <Button type="primary" href={DOMAIN}>
            Back Home
          </Button>
          <Button type="default" onClick={handleLogout}>
            Logout
          </Button>
        </>
      }
    />
  );
}
